import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = null;

const callWidgetReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_GET_CALL_WIDGETS: {
            return (state = action.callWidgets
                ? new Map(
                      listToMap(fromJS(action.callWidgets), (e) =>
                          e.get('key'),
                      ),
                  )
                : null);
        }
        case Actions.RESULT_UPDATE_CALL_WIDGET: {
            const callWidget = action.callWidget;
            return state
                ? state.set(callWidget.key, fromJS(callWidget))
                : state;
        }
        case Actions.RESULT_DELETE_CALL_WIDGET: {
            return state ? state.delete(action.callWidgetKey) : state;
        }
        case Actions.UPDATE_CALL_WIDGET_TRIGGER_TYPE: {
            return state
                ? state.setIn(
                      [action.callWidgetKey, 'triggerType'],
                      action.triggerType,
                  )
                : state;
        }
        default: {
            return state;
        }
    }
};

export default callWidgetReducer;
